import React, { useState, useEffect } from 'react';
import *  as axios from 'axios';
import * as R from 'ramda';
import { ModalRetraite } from './modals/modalRetraite';
import categoryPro from './../../../../assets/images/svg/105-profile.svg';
import { PensionProfessionalCategoryMapping, FrenchTypes } from '../../../../constants/utils/connectionTypes';
import * as urls from '../../../../constants/webapi/services';



export const Retraite = ({ pensions, isLoading, userId, deathDeclaration }) => {
    const [pensionDetails, setPensionDetails] = useState([]);

    const getAllPensionsDetails = () => {
        return axios.get(urls.searchServiceUrl(FrenchTypes.pension))
            .then(function (response) {
                setPensionDetails(response.data.items);
            });
    };

    useEffect(() => {
        getAllPensionsDetails();
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, []);


    if (pensionDetails.length === 0) {
        return "";
    }

    return (
        <section className="card mb-0 bg-common rounded-top-0 pb-4">
            <div className="card-header pb-0 bg-none">
                <div className="grid grid-md-2 align-items-center bg-white px-3 py-1 rounded">
                    <h2 className="h6 text-uppercase text-default font-weight-bolder my-auto">
                        {/* <div className="btn btn-square btn-secondary p-2 mr-2 fs-3 font-weight-bold rounded-sm">1</div> */}
                        <span className="">Retraité(e)</span>
                    </h2>
                    <div className="grid grid-2 ml-auto align-items-center">
                        <button type="button" data-toggle="modal" data-target="#retraiteModal" className="btn btn-icon p-1 align-middle o-80 o-100--hover mx-auto"><i className="eva eva-edit-2-outline align-middle fs-lead"></i></button>
                        <div className="custom-control custom-switch mx-auto">
                            <input type="checkbox" className="custom-control-input" id="retraiteSwitchCheckDefault" required="required" defaultChecked={deathDeclaration.onBoardingStep > 3} />
                            <label className="custom-control-label" htmlFor="retraiteSwitchCheckDefault">Valider</label>
                        </div>
                    </div>
                </div>
                {/* <hr className="mb-0" /> */}
            </div>
            {!R.isNil(pensions) && pensions.length > 0 ?
                pensions.map((pension) => {

                    if (pensionDetails.length === 0) {
                        return "";
                    }

                    let category = PensionProfessionalCategoryMapping.find(c => c.options.find(o => o.value === pension.payload.professionalCategory) !== undefined);
                    let subcategory = category.options.find(o => o.value === pension.payload.professionalCategory);
                    let pensionBaseDetails = undefined;
                    let pensionComplementDetails = undefined;
                    if (pension.payload.professionalCategory !== "Autres") {
                        pensionDetails.forEach((o) => {
                            let pensionBaseBranch = o.branches.find(b => b.id === pension.payload.pensionBaseServiceId);
                            if (!R.isNil(pensionBaseBranch)) {
                                pensionBaseDetails = { ...pensionBaseBranch, regime: o.name };
                            }

                            let pensionComplementBranch = o.branches.find(b => b.id === pension.payload.pensionComplementServiceId);
                            if (!R.isNil(pensionComplementBranch)) {
                                pensionComplementDetails = { ...pensionComplementBranch, regime: o.name };
                            }
                            if (!R.isNil(pensionBaseDetails) && !R.isNil(pensionComplementBranch)) {
                                return;
                            }
                        });
                    } else {
                        pensionBaseDetails = pension.payload.customPensionBase;
                        pensionBaseDetails.regime = subcategory.value;

                        pensionComplementDetails = pension.payload.customPensionComplement;
                        pensionComplementDetails.regime = subcategory.value;
                    }

                    if (!R.isNil(pension.payload.customPensionBase.name) || !R.isNil(pension.payload.customPensionComplement.name)) {
                        pensionBaseDetails = pension.payload.customPensionBase;
                        pensionBaseDetails.regime = subcategory.value;

                        pensionComplementDetails = pension.payload.customPensionComplement;
                        pensionComplementDetails.regime = subcategory.value;
                    }

                    return (
                        <div className="card-body gy-2" key={"pension_" + pension.id}>
                            <div className="grid grid-sm-2 grid-lg-3 grid-xl-5 align-items-start gx-2">
                                <div className="block flex-row align-items-center">
                                    <img className="img-fluid mr-3 h-4" src={categoryPro} alt="building" />
                                    <p className="h6 text-uppercase font-weight-bold my-auto">{subcategory.title}</p>
                                </div>
                                {
                                    R.isNil(pensionBaseDetails) ?
                                        <div className="flex-column align-items-start grid-column-xl-2"></div>
                                        :
                                        <div className="flex-column align-items-start grid-column-xl-2">
                                            <p className="small o-50 font-weight-bol mt-0 mb-2 ls-2 lh-1">Régime de base</p>
                                            <div className="flex-row align-items-center gx-1 w-100">
                                                <div className="block flex-column align-items-start w-50">
                                                    <p className="h6 text-uppercase font-weight-bold my-auto">{pensionBaseDetails.regime}</p>
                                                    <p className="h5 text-uppercase font-weight-bold my-auto o-70">{pensionBaseDetails.name}</p>
                                                </div>
                                                <div className="flex-row align-items-start w-50">
                                                    {pensionBaseDetails.address.streetAddress && <i className="eva lh-copy eva-home-outline mr-2 o-50"></i>}
                                                    <p className="h5 lh-copy my-auto">
                                                        {pensionBaseDetails.address.streetAddress}
                                                        {!R.isNil(pensionBaseDetails.address.streetAddress2) ? <><br />{pensionBaseDetails.address.streetAddress2}</> : ""}
                                                        {!R.isNil(pensionBaseDetails.address.streetAddress3) ? <><br />{pensionBaseDetails.address.streetAddress3}</> : ""}
                                                        <br />{pensionBaseDetails.address.postalCode} {pensionBaseDetails.address.addressLocality}
                                                    </p>
                                                </div>
                                            </div>
                                        </div>
                                }
                                {
                                    R.isNil(pensionComplementDetails) ?
                                        <div className="flex-column align-items-start grid-column-xl-2"></div>
                                        :
                                        <div className="flex-column align-items-start grid-column-xl-2">
                                            <p className="small o-50 font-weight-bol mt-0 mb-2 ls-2 lh-1">Régime complémentaire</p>
                                            <div className="flex-row align-items-center gx-1 ">
                                                <div className="block flex-column align-items-start">
                                                    <p className="h6 text-uppercase font-weight-bold my-auto">{pensionComplementDetails.regime}</p>
                                                    <p className="h5 text-uppercase font-weight-bold my-auto o-70">{pensionComplementDetails.name}</p>
                                                </div>
                                                <div className="flex-row align-items-start">
                                                    {pensionComplementDetails.address.streetAddress && <i className="eva lh-copy eva-home-outline mr-2 o-50"></i>}
                                                    <p className="h5 lh-copy my-auto">
                                                        {pensionComplementDetails.address.streetAddress}
                                                        {!R.isNil(pensionComplementDetails.address.streetAddress2) ? <><br />{pensionComplementDetails.address.streetAddress2}</> : ""}
                                                        {!R.isNil(pensionComplementDetails.address.streetAddress3) ? <><br />{pensionComplementDetails.address.streetAddress3}</> : ""}
                                                        <br />{pensionComplementDetails.address.postalCode} {pensionComplementDetails.address.addressLocality}
                                                    </p>
                                                </div>
                                            </div>
                                        </div>
                                }
                            </div>
                        </div>
                    );
                }) :
                <div className="card-body flex-row">
                    <i className="eva fs-5 text-primary eva-slash-outline mr-2 mt-border"></i>
                    <div className="block">
                        <h1 className="h1 mb-0">C'est vide...</h1>
                        <p className="mt-0 o-80">Compléter votre situation professionnelle</p>
                        <button type="button" data-toggle="modal" data-target="#retraiteModal" className="btn btn-white-primary text-primary">Ajouter</button>
                    </div>
                </div>
            }
            {/* <div className="card-footer">
                <hr className="mt-0" />
                <div className="flex-row align-items-center">
                    <h2 className="h4 text-uppercase o-70 font-weight-bolder my-auto">RETRAITÉ</h2>
                    <span className="h5 font-weight-bold my-auto ml-auto o-40">Non</span>
                </div>
            </div> */}
            <ModalRetraite pensions={pensions} isLoading={isLoading} userId={userId} pensionDetails={pensionDetails} />
        </section>
    );
};